/** Returns the apex URL to send a www.<host> visitor to, or null when the host is already canonical. */
export function canonicalUrl(loc, backendUrl) {
  const apex = new URL(backendUrl).host.replace(/^www\./, "");
  if (loc.host !== `www.${apex}`) return null;
  return `https://${apex}${loc.pathname}${loc.search}${loc.hash}`;
}
